module.exports = __webpack_public_path__ + "static/img/khfw22_1.2794e11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/customer_service/khfw22_1.jpg
// module id = OK41
// module chunks = 3